import { ViewResource } from '../resources';
import ImsObjectCollection from './ims_object_collection.service';
import { View } from './view';
import { IIntervalService } from 'angular';
import { StartupRegistry } from 'app/startup/registry/registry';
import { ILocalStorageService } from 'angular-local-storage';

export class ViewCollection extends ImsObjectCollection<View> {
    constructor(
        startUpRegistry: StartupRegistry,
        localStorageService: ILocalStorageService,
        $interval: IIntervalService,
    ) {
        super(startUpRegistry, localStorageService, $interval, ViewResource, View);
    }
}
